import { GrantsHistoryInterface } from './GrantsHistoryInterface';
import { GrantsHistoryInterfaceType } from '@clientos/types';
import { internalLogger } from '../../clientOsLogger';

let grantsHistoryInterface: GrantsHistoryInterface;

export function getSessionInterfaceV1(): GrantsHistoryInterfaceType {
  return grantsHistoryInterface.getInterface();
}

export default async function initializegrantsHistoryInterfaceV1(): Promise<GrantsHistoryInterfaceType> {
  if (grantsHistoryInterface) return grantsHistoryInterface.getInterface();
  grantsHistoryInterface = new GrantsHistoryInterface();

  return grantsHistoryInterface.getInterface();
}

export function createNoopGrantsHistoryInterface(): GrantsHistoryInterfaceType {
  return {
    refresh: function (): Promise<void> {
      internalLogger?.debug?.d5({
        className: 'createNoopGrantsHistoryInterface',
        methodName: 'refresh()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    checkGrantsHistory: function (): Promise<boolean> {
      internalLogger?.debug?.d5({
        className: 'createNoopGrantsHistoryInterface',
        methodName: 'checkGrantsHistory()',
        message: 'Noop interface method called - returning false'
      });
      return Promise.resolve(false);
    },
    useReactCheckGrantsHistory() {
      internalLogger?.debug?.d5({
        className: 'createNoopGrantsHistoryInterface',
        methodName: 'useReactCheckGrantsHistory()',
        message: 'Noop interface method called - returning false'
      });
      return {
        loading: false,
        reload: () => Promise.resolve(),
        data: false,
        error: undefined
      };
    }
  };
}
